import React from "react";
import { useState } from "react";
import ProductCard from "./ProductCard";

const SizeVariationsCard = ({ item, type }) => {
  const [selectedType, setselectedType] = useState("");

  return (
    <ProductCard
      item={item}
      children={
        <>
          Sizes :
          {item.variations.map((el) => (
            <button
              key={el._id}
              style={{
                background: el.size,
                width: "50px",
                height: "30px",
                borderRadius: "0",
                border:
                  selectedType == el.size
                    ? "3px solid black"
                    : "1px solid black",
              }}
              onClick={() => {
                setselectedType(el.size);
                // setfeaturedImage(el?.images?.featuredImage?.src);
              }}
            >
              {el?.size?.toUpperCase()}
            </button>
          ))}
        </>
      }
    />
  );
};
{
  /**  <Grid item xs={3} key={item._id + "imde"}>
      <Card
        border={"1px solid red"}
        onClick={() => navigate("/single-product/" + item._id)}
      >
        <img
          src={featuredImage}
          style={{
            width: "full",
            height: "300px",
            objectFit: "cover",
            objectPosition: "center",
          }}
          alt="x"
        />
        <br />
        <Typography variant="h6">{item.name}</Typography>
        <p
          dangerouslySetInnerHTML={{
            __html: item?.shortDescription?.substring(0, 80) + "...",
          }}
        ></p>
        <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
          ₹ {price || "NA"} &nbsp;&nbsp;&nbsp;
        </Typography>
        <Rating
          value={
            item?.reviews?.reduce((acc, el) => acc + el.rating, 0) /
            item?.reviews?.length
          }
          readOnly
        />
        <div
          style={{
            height: "30px",
            display: "flex",
            gap: "5px",
            alignItems: "center",
            margin: "10px 0px",
          }}
        >
        
        </div>
        <Box
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            gap: 3,
          }}
        >
           <Button variant="outlined" border={"1px solid #ddd"}>
            Add to Cart
          </Button> 
          </Box>
          </Card>
        </Grid>
*/
}

export default SizeVariationsCard;
